export type RouteQueryValue = string | (string | null)[] | null | undefined

export function parseTemplateQueryParam(raw: RouteQueryValue): string[] {
  if (raw === null || raw === undefined) return []
  if (Array.isArray(raw))
    return raw.filter((v): v is string => typeof v === "string")
  return [raw]
}

export function serializeTemplateQueryParam(
  templates: string[],
): string[] | undefined {
  return templates.length > 0 ? templates : undefined
}
